import { render } from "./ProjectResultDetails.vue?vue&type=template&id=7d7ef543"
import script from "./ProjectResultDetails.vue?vue&type=script&lang=js"
export * from "./ProjectResultDetails.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__